export const getPhotoIdentityFromStoragePath = (storagePath: string): string => {
  const trimmedPath = storagePath.trim();
  if (!trimmedPath) {
    return '';
  }

  const pathWithoutQuery = trimmedPath.split('?')[0] ?? trimmedPath;
  const normalizedPath = pathWithoutQuery.endsWith('/')
    ? pathWithoutQuery.slice(0, -1)
    : pathWithoutQuery;
  const segments = normalizedPath.split('/');
  const lastSegment = segments.length > 0 ? segments[segments.length - 1] : undefined;

  return lastSegment ?? normalizedPath;
};

export const getFaceScreeningMediaIdentity = (params: {
  mediaIdentity?: string;
  mediaStoragePath: string;
}): string => {
  if (params.mediaIdentity && params.mediaIdentity.trim().length > 0) {
    return params.mediaIdentity;
  }

  return getPhotoIdentityFromStoragePath(params.mediaStoragePath);
};
